/**
 * Parses an overlay color to its CSS value based on the theme.
 *
 * @param theme - The theme object.
 * @param color - The color or alias to resolve a value for.
 */ function parseOverlayColor(theme) {
    return theme.aliases.overlayColors.base;
}

export { parseOverlayColor };
//# sourceMappingURL=overlay-color.js.map
